export default {
  instruction: `
    Play the video to learn more about the coronavirus vaccine.
  `,
  done: `
    Click the <b>Done</b> button when you are done watching.
  `,
};
